import React, { useEffect, useState } from 'react';
import './index.css'
import { Menu } from 'antd';
import {Link} from 'react-router-dom'
import { DEFAULT_SITE_NAVIGATION, fetchSiteNavigation, publicNavigationItems } from '../../siteNavigation';

const logo = require('../../imgs/agist-template/02-training-conference.webp');

export default function UHeader() {
  const [navigation, setNavigation] = useState(DEFAULT_SITE_NAVIGATION);

  useEffect(() => {
    let cancelled = false;
    fetchSiteNavigation()
      .then((data) => {
        if (!cancelled) setNavigation(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const currentConferences = publicNavigationItems(navigation.current_conferences);
  const pastConferences = publicNavigationItems(navigation.past_conferences);
  const workshops = publicNavigationItems(navigation.workshops);
  const publications = publicNavigationItems(navigation.publications);
  const conferenceLink = currentConferences[0] || pastConferences[0] || DEFAULT_SITE_NAVIGATION.current_conferences[0];
  const workshopLink = workshops[0] || DEFAULT_SITE_NAVIGATION.workshops[0];
  const publicationLink = publications[0] || DEFAULT_SITE_NAVIGATION.publications[0];
  const linkLabel = (index, label, href) => (
    <a className="template-menu-link" href={href}>
      <span>{String(index).padStart(2, '0')}</span>
      {label}
    </a>
  );

  const childLink = (item) => <a href={item.url}>{item.label}</a>;

  const navItems = [
    { label: 'Home', href: '#/home' },
    { label: 'About AGIST', href: '#/about' },
    { label: 'Membership', href: '#/membership' },
    {
      label: navigation.conference_menu_title || 'Conferences',
      href: conferenceLink.url,
      children: [
        ...currentConferences,
        {
          label: navigation.past_conferences_title || 'Past Conferences',
          url: '#',
          children: pastConferences,
        },
        navigation.registration_link?.visible !== false ? navigation.registration_link : null,
      ].filter(Boolean),
    },
    { label: navigation.workshops_title || 'Workshops and Training', href: workshopLink.url, children: workshops },
    { label: navigation.publications_title || 'Publications', href: publicationLink.url, children: publications },
    { label: 'News', href: '#/news' },
    { label: 'Contacts', href: '#/contact' },
  ];

  const desktopMenuItems = navItems.map((item, index) => ({
    key: `nav-${index}`,
    label: linkLabel(index + 1, item.label, item.href),
    popupClassName: 'template-submenu-popup',
    children: item.children?.map((child, childIndex) => ({
      key: `nav-${index}-${childIndex}`,
      label: child.children?.length ? child.label : childLink(child),
      popupClassName: 'template-submenu-popup',
      children: child.children?.map((nested, nestedIndex) => ({
        key: `nav-${index}-${childIndex}-${nestedIndex}`,
        label: childLink(nested),
      })),
    })),
  }));

  const renderMobileSubnav = (items, parentLabel) => (
    <div className="mobile-subnav">
      {items.map((child) => (
        <React.Fragment key={`${parentLabel}-${child.label}-${child.url}`}>
          <a href={child.url}>{child.label}</a>
          {child.children?.length > 0 && renderMobileSubnav(child.children, `${parentLabel}-${child.label}`)}
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <header className="site-header">
      <div className="utility-bar">
        <div className="shell utility-inner">
          <p>Association of Global Intelligent Science and Technology</p>
          <div>
            <a href="mailto:info@agist.org">info@agist.org</a>
            <span aria-hidden="true">&middot;</span>
            <a href="https://twitter.com/DaoAgist">X / Twitter</a>
          </div>
        </div>
      </div>
      <div className="shell nav-row">
        <Link className="brand" to="/home" aria-label="AGIST home">
          <img src={logo} alt="AGIST" />
        </Link>
        <p className="brand-statement">Global research &middot; Education &middot; Scholarly exchange</p>
        <Link className="nav-cta" to="/membership">Join AGIST <span aria-hidden="true">{'\u2197'}</span></Link>
        <details className="mobile-menu">
          <summary>Menu</summary>
          <nav aria-label="Mobile navigation">
            {navItems.map((item) => (
              <div className="mobile-nav-group" key={item.label}>
                <a href={item.href}>{item.label}</a>
                {item.children?.length > 0 && renderMobileSubnav(item.children, item.label)}
              </div>
            ))}
          </nav>
        </details>
      </div>
      <div className="menu-bar">
        <Menu
          className="shell desktop-nav template-ant-menu"
          mode="horizontal"
          selectable={false}
          triggerSubMenuAction="hover"
          items={desktopMenuItems}
        />
      </div>
    </header>
  )
}
